import React from "react";
import { Heading } from "@/components/ui/typography";
import Image from "next/image";
import { Search } from "lucide-react";

type Props = {
  searchQuery: string;
  onSearchChange: (value: string) => void;
};

function HeroSection({ searchQuery, onSearchChange }: Props) {
  return (
    <div className="relative min-h-[340px] sm:min-h-[420px] md:h-[500px]">
      <Image
        src="/blogs/hero.png"
        className="absolute object-cover"
        fill
        alt="Bg"
        priority
      />
      {/* hero.png is a light decorative gradient, not a subject photo — dim it
          so the white heading/search bar stay legible on the dark theme.
          Placed before the two accent photos so only the background dims. */}
      <div className="absolute inset-0 bg-black/80" />
      <Image
        src="/blogs/top.png"
        className="absolute max-sm:hidden w-[146px] right-32 top-40 rounded-2xl"
        height={122}
        width={146}
        alt="Bg"
        priority
      />
      <Image
        src="/blogs/bottom.png"
        className="absolute max-sm:hidden w-[146px] left-32 bottom-14 rounded-2xl"
        height={122}
        width={146}
        alt="Bg"
        priority
      />
      <div className="relative mx-auto flex items-center justify-center h-full max-w-[1200px] px-4 min-[1240px]:px-0 py-12 md:py-0">
        <div className="flex flex-col items-center justify-center gap-5 sm:gap-8 w-full max-w-[764px]">
          <Heading as="h1" variant="hero">
            Our Latest Blogs
          </Heading>
          <p className="font-inter leading-[24px] text-center text-[15px] sm:text-[18px] text-white/70">
            Expert insights on offshore banking, international incorporation,
            tax structures, and building borderless businesses in 2026.
          </p>
          <div className="flex items-center gap-3 w-full bg-[#0f1218] border border-white/10 rounded-full px-5 py-3 shadow-sm">
            <Search className="text-white/60 shrink-0" size={20} />
            <input
              type="text"
              placeholder="Search articles, topics..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className="flex-1 bg-transparent outline-none text-[15px] sm:text-[16px] font-inter text-white/70 placeholder:text-white/60"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
